// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_PprBu {
  max-height : 250px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-fota-management/lib/views/itemEditor/attributeEditors/fotaItemMultiSelector/FotaItemMultiSelector.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB","sourcesContent":[".container {\n  max-height : 250px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_PprBu`
};
export default ___CSS_LOADER_EXPORT___;
